<template>
  <div class="n-container n-user-menu-title-container text-lg text-bold sticky top-4 bg-white z-10 h-[fit-content] md:hidden">
    <i class="mr-1 pt-3" :class="curMenu.meta.icon ?? curMenu.meta.parentIcon"></i>
    {{ $te(curMenu.name) ? $t(curMenu.name) : $t(curMenu.meta.parentName) }}
  </div>
  <div class="n-container py-6 n-user-menu-content-container min-h-[620px]">
    <div class="flex">
      <ul class="n-user-side-menus-container c-side-menus n-card p-2 md:p-5 hidden md:block space-y-3 h-[fit-content] mr-4">
        <li
          v-for="item in menus"
          :key="item.name"
          class="w-[170px] text-lg flex items-center h-8 px-5 py-6 n-card select-none n-row-hover whitespace-nowrap"
          :class="{ 'c-active-menu': curMenu.name === item.name || curMenu.meta.parentName === item.name }"
          @click="routerTo(item.path)"
        >
          <i class="mr-3 w-[23px]" :class="item.icon" /> {{ $t(item.name) }}
        </li>
      </ul>
      <div class="flex-1 n-card p-5 overflow-auto md:min-h-[500px]">
        <RouterView />
      </div>
    </div>
  </div>
</template>

<script setup>
import menus from '@front/menus';
import {computed, ref, watchEffect} from 'vue';
import {useBootstrap, useRouter} from '@front/hooks';

const { router, routerTo } = useRouter();
const { userProfile } = useBootstrap();

const imageUrl = ref('');

const curMenu = computed(() => router.currentRoute.value);

watchEffect(() => {
  imageUrl.value = userProfile.value.imageUrl || '/images/default_avatar.jpeg';
});
</script>

<script>
export default {
  name: 'UserIndex',
};
</script>

<style lang="less">
.banner-card {
  background-image: url('/images/client/bg.png');
  background-position: center;
  background-color: var(--ant-primary-color);
}

.c-active-menu {
  color: var(--ant-primary-color);
}
</style>
